export default __webpack_public_path__ + "static/media/positeams-logo.a80699d9.png";